import React from 'react';
import { InputSwitch } from 'primereact/inputswitch';
import clsx from 'clsx';

interface ComponentProps {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  className?: string;
  name?: string;
  dataTestId?: string;
}

const RingilInputSwitch: React.FC<ComponentProps> = ({ value, name, label, onChange, disabled = false, className, dataTestId }) => {
  return (
    <div className={clsx('flex flex-row gap-2 items-center', className)} data-testid={dataTestId}>
      <InputSwitch checked={value} name={name} onChange={e => onChange(e.target.value)} disabled={disabled} />
      <label htmlFor={name} className={clsx('font-medium', disabled ? 'text-content-tertiary' : 'text-content-primary')}>
        {label}
      </label>
    </div>
  );
};

export default RingilInputSwitch;
